import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { DeliveryServiceResource } from "@exonn/js-sdk";

export const module: ModuleOptions<DeliveryServiceResource> = {
  resource: ResourceEnum.DeliveryService,
  bigIcon: <span className={"icon-20-deliv_cost"} />,
  smallIcon: <span className={"icon-15-deliv_cost"} />,
};
